/* eslint-disable prettier/prettier */
/**
 * SADEMS Demo - Mock Data
 * Datos realistas para todas las funcionalidades del sistema
 */

// ============ HELPERS ============
const today = new Date();
const formatDate = (d) => d.toISOString().split("T")[0];
const daysAgo = (n) => { const d = new Date(today); d.setDate(d.getDate() - n); return formatDate(d); };
const monthsAgo = (n) => { const d = new Date(today); d.setMonth(d.getMonth() - n); return formatDate(d); };

// ============ MAIN DASHBOARD ============
export const mainDashboardStats = {
  count: 45,
  ingresos: ["$125,000", 3.2],
  sucursales: ["4", 0],
  activos: ["$425,000", 12],
  ingresosPorEmpresa: {
    labels: ["DICA", "ALVA", "TESG", "COOR", "FVPL"],
    datasets: [{ label: "Ingresos", data: [45000, 32000, 28000, 15000, 25000] }]
  },
  acciones: {
    sales: {
      labels: ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"],
      datasets: [{ label: "Ventas", data: [450, 200, 100, 220, 500, 100, 400] }]
    }
  },
  ingresosConsolidados: {
    tasks: {
      labels: ["Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
      datasets: [{ label: "Ingresos", data: [50, 40, 300, 220, 500, 250, 400, 230, 500] }]
    }
  }
};

// ============ AUTH ============
export const MOCK_USER = {
  id: 1,
  name: "Usuario Demo",
  email: "demo@sadems.com",
  role: "Administrador",
  created_at: "2024-01-15",
};

export const MOCK_TOKEN = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxIiwibmFtZSI6IlVzdWFyaW8gRGVtbyIsImVtYWlsIjoiZGVtb0BzYWRlbXMuY29tIiwicm9sZSI6IkFkbWluaXN0cmFkb3IiLCJpYXQiOjE3MDAwMDAwMDAsImV4cCI6OTk5OTk5OTk5OX0.demo-mock-signature";

// ============ EMPRESAS ============
export const empresas = [
  { id: 1, nombre: "Distribuidora Central S.A.", nomcorto: "DICA", RIF: "J-12345678-9", direccion: "Av. Libertador, Torre Central, Piso 5, Caracas", telefono: "0212-555-0101", email: "info@dicentral.com", estado: true, descripcion: "Distribuidora principal de productos", created_at: monthsAgo(12), updated_at: daysAgo(1) },
  { id: 2, nombre: "Alimentos del Valle C.A.", nomcorto: "ALVA", RIF: "J-98765432-1", direccion: "Zona Industrial Sur, Galpón 12, Valencia", telefono: "0241-555-0202", email: "ventas@alvalley.com", estado: true, descripcion: "Procesadora de alimentos", created_at: monthsAgo(10), updated_at: daysAgo(2) },
  { id: 3, nombre: "TechnoServices Group", nomcorto: "TESG", RIF: "J-45678901-2", direccion: "C.C. Millenium, Local 45, Maracaibo", telefono: "0261-555-0303", email: "soporte@technogrp.com", estado: true, descripcion: "Servicios tecnológicos", created_at: monthsAgo(8), updated_at: daysAgo(3) },
  { id: 4, nombre: "Construcciones Oriente C.A.", nomcorto: "COOR", RIF: "J-11223344-5", direccion: "Urb. Las Garzas, Calle 5, Puerto La Cruz", telefono: "0281-555-0404", email: "proyectos@constoriente.com", estado: false, descripcion: "Constructora regional", created_at: monthsAgo(15), updated_at: daysAgo(30) },
  { id: 5, nombre: "FarmaVida Plus C.A.", nomcorto: "FVPL", RIF: "J-55667788-0", direccion: "Av. Bolívar, Edif. Salud, PB, Barquisimeto", telefono: "0251-555-0505", email: "pedidos@farmavida.com", estado: true, descripcion: "Distribuidora farmacéutica", created_at: monthsAgo(6), updated_at: daysAgo(1) },
];

// ============ SUCURSALES ============
export const sucursales = [
  { id: 1, nombre: "Sucursal Principal Caracas", empresa_id: 1, direccion: "Av. Libertador, Caracas", telefono: "0212-555-1001", estado: true, updated_at: daysAgo(1) },
  { id: 2, nombre: "Sucursal Valencia", empresa_id: 2, direccion: "Zona Industrial, Valencia", telefono: "0241-555-1002", estado: true, updated_at: daysAgo(2) },
  { id: 3, nombre: "Sucursal Maracaibo", empresa_id: 3, direccion: "Centro, Maracaibo", telefono: "0261-555-1003", estado: true, updated_at: daysAgo(5) },
  { id: 4, nombre: "Sucursal Barquisimeto", empresa_id: 5, direccion: "Av. Bolívar, Barquisimeto", telefono: "0251-555-1004", estado: true, updated_at: daysAgo(3) },
];

// ============ USUARIOS ============
export const usuarios = [
  { id: 1, name: "Usuario Demo", email: "demo@sadems.com", role: "Administrador", estado: true, created_at: monthsAgo(12) },
  { id: 2, name: "María González", email: "maria@sadems.com", role: "Gerente", estado: true, created_at: monthsAgo(10) },
  { id: 3, name: "Carlos Rodríguez", email: "carlos@sadems.com", role: "Vendedor", estado: true, created_at: monthsAgo(8) },
  { id: 4, name: "Ana Martínez", email: "ana@sadems.com", role: "Contador", estado: true, created_at: monthsAgo(6) },
  { id: 5, name: "Pedro López", email: "pedro@sadems.com", role: "Almacenista", estado: false, created_at: monthsAgo(4) },
];

// ============ ROLES ============
export const roles = [
  { id: 1, nombre: "Administrador", descripcion: "Acceso total al sistema", permisos: ["all"] },
  { id: 2, nombre: "Gerente", descripcion: "Gestión de módulos empresariales", permisos: ["read", "write", "reports"] },
  { id: 3, nombre: "Vendedor", descripcion: "Módulo de ventas y CRM", permisos: ["ventas", "clientes"] },
  { id: 4, nombre: "Contador", descripcion: "Módulo contable y reportes", permisos: ["contabilidad", "reportes"] },
  { id: 5, nombre: "Almacenista", descripcion: "Gestión de inventario", permisos: ["inventario"] },
];

// ============ CATEGORIAS ============
export const categorias = [
  { id: 1, nombre: "Electrónica", descripcion: "Dispositivos electrónicos", created_at: monthsAgo(12) },
  { id: 2, nombre: "Alimentos", descripcion: "Productos alimenticios", created_at: monthsAgo(12) },
  { id: 3, nombre: "Medicamentos", descripcion: "Productos farmacéuticos", created_at: monthsAgo(10) },
  { id: 4, nombre: "Materiales", descripcion: "Materiales de construcción", created_at: monthsAgo(8) },
  { id: 5, nombre: "Papelería", descripcion: "Artículos de oficina", created_at: monthsAgo(6) },
];

// ============ ALMACENES ============
export const almacenes = [
  { id: 1, nombre: "Almacén Principal", ubicacion: "Caracas", capacidad: 5000, empresa_id: 1, estado: true },
  { id: 2, nombre: "Almacén Valencia", ubicacion: "Valencia", capacidad: 3000, empresa_id: 2, estado: true },
  { id: 3, nombre: "Almacén Maracaibo", ubicacion: "Maracaibo", capacidad: 2000, empresa_id: 3, estado: true },
  { id: 4, nombre: "Almacén Barquisimeto", ubicacion: "Barquisimeto", capacidad: 1500, empresa_id: 5, estado: true },
];

// ============ PRODUCTOS / INVENTARIO ============
export const productos = [
  { id: 1, nombre: "Laptop HP ProBook 450", codigo: "ELEC-001", precio: 850.00, cantidad: 45, stock_minimo: 10, categoria_id: 1, almacen_id: 1, unidad: "und", descripcion: "Laptop empresarial", updated_at: daysAgo(1) },
  { id: 2, nombre: "Monitor Dell 24\"", codigo: "ELEC-002", precio: 320.00, cantidad: 30, stock_minimo: 5, categoria_id: 1, almacen_id: 1, unidad: "und", descripcion: "Monitor Full HD", updated_at: daysAgo(2) },
  { id: 3, nombre: "Arroz Premium 1kg", codigo: "ALIM-001", precio: 2.50, cantidad: 500, stock_minimo: 100, categoria_id: 2, almacen_id: 2, unidad: "kg", descripcion: "Arroz de primera", updated_at: daysAgo(1) },
  { id: 4, nombre: "Harina PAN 1kg", codigo: "ALIM-002", precio: 1.80, cantidad: 800, stock_minimo: 200, categoria_id: 2, almacen_id: 2, unidad: "kg", descripcion: "Harina precocida", updated_at: daysAgo(3) },
  { id: 5, nombre: "Acetaminofén 500mg", codigo: "MED-001", precio: 5.00, cantidad: 200, stock_minimo: 50, categoria_id: 3, almacen_id: 4, unidad: "caja", descripcion: "Analgésico", updated_at: daysAgo(2) },
  { id: 6, nombre: "Cemento Portland 50kg", codigo: "MAT-001", precio: 12.00, cantidad: 150, stock_minimo: 30, categoria_id: 4, almacen_id: 3, unidad: "saco", descripcion: "Cemento tipo I", updated_at: daysAgo(5) },
  { id: 7, nombre: "Resma Papel A4", codigo: "PAP-001", precio: 8.50, cantidad: 120, stock_minimo: 20, categoria_id: 5, almacen_id: 1, unidad: "resma", descripcion: "Papel bond A4", updated_at: daysAgo(1) },
  { id: 8, nombre: "Teclado Logitech K120", codigo: "ELEC-003", precio: 25.00, cantidad: 60, stock_minimo: 15, categoria_id: 1, almacen_id: 1, unidad: "und", descripcion: "Teclado USB", updated_at: daysAgo(4) },
];

// ============ MOVIMIENTOS ============
export const movimientos = [
  { id: 1, tipo_movimiento: "entrada", descripcion: "Recepción de laptops HP", cantidad: 20, fecha_movimiento: daysAgo(1), producto_id: 1, almacen_id: 1 },
  { id: 2, tipo_movimiento: "salida", descripcion: "Despacho a Sucursal Valencia", cantidad: 50, fecha_movimiento: daysAgo(1), producto_id: 3, almacen_id: 2 },
  { id: 3, tipo_movimiento: "entrada", descripcion: "Compra de monitores Dell", cantidad: 15, fecha_movimiento: daysAgo(2), producto_id: 2, almacen_id: 1 },
  { id: 4, tipo_movimiento: "transferencia", descripcion: "Transferencia entre almacenes", cantidad: 30, fecha_movimiento: daysAgo(3), producto_id: 4, almacen_id: 2 },
  { id: 5, tipo_movimiento: "salida", descripcion: "Venta de cemento a cliente", cantidad: 25, fecha_movimiento: daysAgo(4), producto_id: 6, almacen_id: 3 },
  { id: 6, tipo_movimiento: "entrada", descripcion: "Reposición de medicamentos", cantidad: 100, fecha_movimiento: daysAgo(5), producto_id: 5, almacen_id: 4 },
  { id: 7, tipo_movimiento: "salida", descripcion: "Entrega de papelería", cantidad: 10, fecha_movimiento: daysAgo(6), producto_id: 7, almacen_id: 1 },
  { id: 8, tipo_movimiento: "entrada", descripcion: "Recepción de teclados", cantidad: 30, fecha_movimiento: daysAgo(7), producto_id: 8, almacen_id: 1 },
];

// ============ CLIENTES ============
export const clientes = [
  { id: 1, nombre: "Corporación XYZ", rif: "J-30567890-1", email: "compras@corpxyz.com", telefono: "0212-555-2001", direccion: "Caracas", tipo: "Jurídico", estado: true },
  { id: 2, nombre: "Juan Pérez", rif: "V-15234567", email: "jperez@gmail.com", telefono: "0414-555-2002", direccion: "Valencia", tipo: "Natural", estado: true },
  { id: 3, nombre: "Supermercados Del Este C.A.", rif: "J-40123456-7", email: "pedidos@supereste.com", telefono: "0212-555-2003", direccion: "Caracas", tipo: "Jurídico", estado: true },
  { id: 4, nombre: "María Fernández", rif: "V-18765432", email: "mfernandez@hotmail.com", telefono: "0424-555-2004", direccion: "Maracaibo", tipo: "Natural", estado: true },
  { id: 5, nombre: "Ferretería Los Andes", rif: "J-50987654-3", email: "ventas@ferreandes.com", telefono: "0274-555-2005", direccion: "Mérida", tipo: "Jurídico", estado: true },
];

// ============ VENTAS ============
const generateVentas = () => {
  const ventas = [];
  for (let i = 1; i <= 30; i++) {
    const day = daysAgo(Math.floor(Math.random() * 60));
    ventas.push({
      id: i,
      numero_factura: `FAC-${String(i).padStart(6, "0")}`,
      cliente_id: (i % 5) + 1,
      cliente_nombre: clientes[(i % 5)].nombre,
      fecha_venta: day,
      subtotal: (Math.random() * 5000 + 100).toFixed(2),
      impuesto: (Math.random() * 800 + 16).toFixed(2),
      total: (Math.random() * 5800 + 116).toFixed(2),
      estado: i % 7 === 0 ? "anulada" : i % 3 === 0 ? "pendiente" : "completada",
      sucursal_id: (i % 4) + 1,
      metodo_pago: ["Efectivo", "Transferencia", "Tarjeta", "Crédito"][i % 4],
      created_at: day,
    });
  }
  return ventas;
};
export const ventas = generateVentas();

// ============ METODOS DE PAGO ============
export const metodosPago = [
  { id: 1, nombre: "Efectivo", activo: true },
  { id: 2, nombre: "Transferencia Bancaria", activo: true },
  { id: 3, nombre: "Tarjeta de Débito", activo: true },
  { id: 4, nombre: "Tarjeta de Crédito", activo: true },
  { id: 5, nombre: "Pago Móvil", activo: true },
];

// ============ PROVEEDORES ============
export const proveedores = [
  { id: 1, nombre: "Importadora Global C.A.", rif: "J-20345678-1", email: "ventas@impglobal.com", telefono: "0212-555-3001", direccion: "Caracas", tipo: "Nacional", estado: true },
  { id: 2, nombre: "Suministros Tech S.A.", rif: "J-30456789-2", email: "info@sumtech.com", telefono: "0241-555-3002", direccion: "Valencia", tipo: "Nacional", estado: true },
  { id: 3, nombre: "Alimentos Frescos del Campo", rif: "J-40567890-3", email: "pedidos@alfrescam.com", telefono: "0251-555-3003", direccion: "Barquisimeto", tipo: "Nacional", estado: true },
  { id: 4, nombre: "MediSupply International", rif: "J-50678901-4", email: "orders@medisupply.com", telefono: "+1-555-3004", direccion: "Miami, FL", tipo: "Internacional", estado: true },
];

// ============ COMPRAS ============
export const compras = [
  { id: 1, numero_orden: "OC-000001", proveedor_id: 1, proveedor_nombre: "Importadora Global C.A.", fecha_compra: daysAgo(5), total: 15000.00, estado: "completada", created_at: daysAgo(5) },
  { id: 2, numero_orden: "OC-000002", proveedor_id: 2, proveedor_nombre: "Suministros Tech S.A.", fecha_compra: daysAgo(10), total: 8500.00, estado: "completada", created_at: daysAgo(10) },
  { id: 3, numero_orden: "OC-000003", proveedor_id: 3, proveedor_nombre: "Alimentos Frescos del Campo", fecha_compra: daysAgo(2), total: 3200.00, estado: "pendiente", created_at: daysAgo(2) },
  { id: 4, numero_orden: "OC-000004", proveedor_id: 4, proveedor_nombre: "MediSupply International", fecha_compra: daysAgo(15), total: 22000.00, estado: "completada", created_at: daysAgo(15) },
  { id: 5, numero_orden: "OC-000005", proveedor_id: 1, proveedor_nombre: "Importadora Global C.A.", fecha_compra: daysAgo(1), total: 6700.00, estado: "pendiente", created_at: daysAgo(1) },
];

// ============ COTIZACIONES ============
export const cotizaciones = [
  { id: 1, numero: "COT-000001", proveedor_id: 1, proveedor_nombre: "Importadora Global C.A.", fecha: daysAgo(7), total: 18000.00, estado: "aprobada" },
  { id: 2, numero: "COT-000002", proveedor_id: 2, proveedor_nombre: "Suministros Tech S.A.", fecha: daysAgo(3), total: 5600.00, estado: "pendiente" },
  { id: 3, numero: "COT-000003", proveedor_id: 3, proveedor_nombre: "Alimentos Frescos del Campo", fecha: daysAgo(1), total: 2100.00, estado: "pendiente" },
];

// ============ RECEPCIONES ============
export const recepciones = [
  { id: 1, numero: "REC-000001", compra_id: 1, fecha: daysAgo(3), estado: "completada", observaciones: "Recepción completa" },
  { id: 2, numero: "REC-000002", compra_id: 2, fecha: daysAgo(8), estado: "completada", observaciones: "Sin novedades" },
  { id: 3, numero: "REC-000003", compra_id: 4, fecha: daysAgo(12), estado: "parcial", observaciones: "Faltaron 5 unidades" },
];

// ============ INVENTARIO STATS ============
export const inventarioEstadisticas = {
  total_productos: 8,
  total_stock: 1905,
  valor_total: 89250.00,
  stock_bajo: 0,
  categorias_activas: 5,
  almacenes_activos: 4,
};

export const inventarioMovimientosChart = {
  labels: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
  datasets: [
    { label: "Entradas", data: [45, 52, 38, 60, 55, 70, 48, 62, 50, 58, 65, 42], color: "info" },
    { label: "Salidas", data: [30, 40, 35, 45, 50, 55, 38, 48, 42, 52, 58, 35], color: "dark" }
  ]
};

export const inventarioValorCategoria = {
  labels: categorias.map(c => c.nombre),
  datasets: { label: "Valor", data: [38250, 3250, 1000, 1800, 1020] }
};

export const inventarioStockBajo = [];

export const inventarioValorPorAlmacen = {
  labels: almacenes.map(a => a.nombre),
  datasets: { label: "Valor", data: [40850, 2690, 1800, 1000] }
};

export const inventarioTransferencias = [
  { id: 1, origen: "Almacén Principal", destino: "Almacén Valencia", producto: "Arroz Premium 1kg", cantidad: 100, fecha: daysAgo(3), estado: "completada" },
  { id: 2, origen: "Almacén Valencia", destino: "Almacén Barquisimeto", producto: "Harina PAN 1kg", cantidad: 50, fecha: daysAgo(5), estado: "completada" },
];

export const inventarioAjustes = [
  { id: 1, producto: "Laptop HP ProBook 450", tipo: "Ajuste positivo", cantidad: 5, motivo: "Error en conteo anterior", fecha: daysAgo(10) },
  { id: 2, producto: "Monitor Dell 24\"", tipo: "Ajuste negativo", cantidad: 2, motivo: "Producto dañado", fecha: daysAgo(15) },
];

// ============ CONTABILIDAD ============
// ============ CONTABILIDAD DASHBOARD ============
export const contabilidadDashboard = {
  totalActivos: 1250000,
  totalPasivos: 450000,
  patrimonio: 800000,
  ingresosDelMes: 320000,
  gastosDelMes: 185000,
  utilidadDelMes: 135000,
  cuentasPorCobrar: 95000,
  cuentasPorPagar: 62000,
  ingresosVsGastos: {
    labels: ["Jun", "Jul", "Ago", "Sep", "Oct", "Nov"],
    ingresos: [280000, 295000, 310000, 305000, 318000, 320000],
    gastos: [165000, 175000, 182000, 178000, 180000, 185000],
  },
  gastosDistribucion: {
    labels: ["Operativos", "Administrativos", "Ventas", "Financieros", "Otros"],
    values: [75000, 45000, 35000, 20000, 10000],
  },
};

export const contabilidadCuentas = [
  { id: 1, codigo: "1.1.01", nombre: "Caja", tipo: "Activo", saldo: 15000.00, nivel: 3 },
  { id: 2, codigo: "1.1.02", nombre: "Bancos", tipo: "Activo", saldo: 85000.00, nivel: 3 },
  { id: 3, codigo: "1.2.01", nombre: "Cuentas por Cobrar", tipo: "Activo", saldo: 45000.00, nivel: 3 },
  { id: 4, codigo: "2.1.01", nombre: "Cuentas por Pagar", tipo: "Pasivo", saldo: 32000.00, nivel: 3 },
  { id: 5, codigo: "3.1.01", nombre: "Capital Social", tipo: "Patrimonio", saldo: 200000.00, nivel: 3 },
  { id: 6, codigo: "4.1.01", nombre: "Ventas", tipo: "Ingreso", saldo: 125000.00, nivel: 3 },
  { id: 7, codigo: "5.1.01", nombre: "Costo de Ventas", tipo: "Gasto", saldo: 60000.00, nivel: 3 },
  { id: 8, codigo: "5.2.01", nombre: "Gastos Administrativos", tipo: "Gasto", saldo: 27000.00, nivel: 3 },
];

export const contabilidadAsientos = [
  { id: 1, numero: "AS-000001", fecha: daysAgo(1), descripcion: "Registro de ventas del día", debe: 5800.00, haber: 5800.00, estado: "aprobado" },
  { id: 2, numero: "AS-000002", fecha: daysAgo(2), descripcion: "Pago a proveedor Global", debe: 15000.00, haber: 15000.00, estado: "aprobado" },
  { id: 3, numero: "AS-000003", fecha: daysAgo(3), descripcion: "Cobro factura cliente XYZ", debe: 8500.00, haber: 8500.00, estado: "aprobado" },
  { id: 4, numero: "AS-000004", fecha: daysAgo(5), descripcion: "Nómina quincenal", debe: 22000.00, haber: 22000.00, estado: "pendiente" },
];

export const contabilidadBalanceGeneral = {
  activos: {
    circulante: [
      { cuenta: "Caja/Bancos", monto: 100000.00 },
      { cuenta: "Cuentas por Cobrar", monto: 45000.00 }
    ],
    fijo: [
      { cuenta: "Mobiliario y Equipo", monto: 180000.00 },
      { cuenta: "Vehículos", monto: 100000.00 }
    ]
  },
  pasivos: {
    corto_plazo: [
      { cuenta: "Cuentas por Pagar", monto: 55000.00 },
      { cuenta: "Impuestos por Pagar", monto: 10000.00 }
    ],
    largo_plazo: [
      { cuenta: "Préstamos Bancarios", monto: 40000.00 }
    ]
  },
  capital: [
    { cuenta: "Capital Social", monto: 200000.00 },
    { cuenta: "Utilidad del Ejercicio", monto: 120000.00 }
  ]
};

export const contabilidadEstadoResultados = {
  ingresos: [
    { cuenta: "Ventas de Mercancía", monto: 125000.00 }
  ],
  costoVentas: [
    { cuenta: "Costo de Ventas", monto: 60000.00 }
  ],
  gastosOperacion: {
    ventas: [
      { cuenta: "Publicidad", monto: 5000.00 },
      { cuenta: "Comisiones", monto: 7000.00 }
    ],
    administracion: [
      { cuenta: "Salarios Admin", monto: 10000.00 },
      { cuenta: "Alquileres", monto: 5000.00 }
    ]
  },
  otrosGastosIngresos: {
    ingresos: [
      { cuenta: "Otros Ingresos", monto: 2000.00 }
    ],
    gastos: [
      { cuenta: "Otros Gastos", monto: 1500.00 }
    ]
  },
  impuestos: { cuenta: "ISR", monto: 500.00 },
};

export const contabilidadFlujoCaja = {
  saldoInicial: 97000.00,
  actividadesOperacion: {
    entradas: [
      { concepto: "Cobro a Clientes", monto: 95000.00 }
    ],
    salidas: [
      { concepto: "Pago a Proveedores", monto: -72000.00 }
    ]
  },
  actividadesInversion: {
    entradas: [],
    salidas: [
      { concepto: "Compra de Equipo", monto: -15000.00 }
    ]
  },
  actividadesFinanciamiento: {
    entradas: [],
    salidas: [
      { concepto: "Pago de Dividendos", monto: -5000.00 }
    ]
  },
  aumentoDisminucion: 3000.00,
  saldoFinal: 100000.00,
};

export const contabilidadLibroMayor = contabilidadCuentas.map((cuenta) => ({
  ...cuenta,
  movimientos: [
    { fecha: daysAgo(1), descripcion: "Movimiento 1", debe: 1000, haber: 0 },
    { fecha: daysAgo(3), descripcion: "Movimiento 2", debe: 0, haber: 500 },
  ],
}));

export const contabilidadReportes = {
  resumen: "Período cerrado correctamente. Todos los asientos están cuadrados.",
};

// ============ RRHH ============
// ============ RRHH DASHBOARD ============
export const rrhhDashboard = {
  stats: {
    totalEmpleados: 45,
    empleadosActivos: 42,
    nuevosEmpleados: 12,
    empleadosInactivos: 3,
    nominaDelMes: 135000,
    promedioSalario: 3200,
    asistenciaPromedio: 94,
    vacacionesPendientes: 12,
  },
  deptData: {
    labels: ["Ventas", "Marketing", "TI", "Operaciones", "RRHH"],
    datasets: [{
      label: "Empleados",
      data: [15, 8, 12, 10, 3],
      backgroundColor: ["#1A73E8", "#34A853", "#FBBC04", "#EA4335", "#8E24AA"]
    }]
  },
  asistenciaData: {
    labels: ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"],
    datasets: [{
      label: "Presentes",
      data: [42, 44, 41, 43, 40, 10, 5],
      backgroundColor: "#1A73E8"
    }]
  },
  nominaData: {
    labels: ["Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
    datasets: [{
      label: "Monto",
      data: [120000, 125000, 122000, 130000, 135000, 140000],
      backgroundColor: "#34A853"
    }]
  }
};

export const rrhhEmpleados = [
  { id: 1, nombre: "Carlos Mendoza", cedula: "V-15234567", cargo: "Gerente General", departamento: "Dirección", salario: 8500.00, fecha_ingreso: monthsAgo(36), estado: "activo", email: "cmendoza@empresa.com" },
  { id: 2, nombre: "Laura Pérez", cedula: "V-18345678", cargo: "Jefe de Ventas", departamento: "Ventas", salario: 5500.00, fecha_ingreso: monthsAgo(24), estado: "activo", email: "lperez@empresa.com" },
  { id: 3, nombre: "Roberto Silva", cedula: "V-20456789", cargo: "Contador", departamento: "Contabilidad", salario: 4800.00, fecha_ingreso: monthsAgo(18), estado: "activo", email: "rsilva@empresa.com" },
  { id: 4, nombre: "Ana Torres", cedula: "V-22567890", cargo: "Analista de RRHH", departamento: "Recursos Humanos", salario: 4200.00, fecha_ingreso: monthsAgo(12), estado: "activo", email: "atorres@empresa.com" },
  { id: 5, nombre: "Miguel Ramos", cedula: "V-19678901", cargo: "Almacenista", departamento: "Logística", salario: 3500.00, fecha_ingreso: monthsAgo(8), estado: "activo", email: "mramos@empresa.com" },
];

export const rrhhNomina = rrhhEmpleados.map((emp) => ({
  id: emp.id, empleado_id: emp.id, empleado_nombre: emp.nombre, salario_base: emp.salario,
  bonificaciones: emp.salario * 0.1, deducciones: emp.salario * 0.15,
  neto_pagar: emp.salario + emp.salario * 0.1 - emp.salario * 0.15,
  periodo: formatDate(today), estado: "pagada",
}));

export const rrhhAsistencias = rrhhEmpleados.map((emp) => ({
  id: emp.id, empleado_id: emp.id, empleado_nombre: emp.nombre,
  fecha: daysAgo(0), hora_entrada: "08:00", hora_salida: "17:00",
  estado: Math.random() > 0.1 ? "presente" : "ausente",
}));

export const rrhhVacaciones = [
  { id: 1, empleado_id: 2, empleado_nombre: "Laura Pérez", fecha_inicio: daysAgo(-5), fecha_fin: daysAgo(-12), dias: 7, estado: "aprobada" },
  { id: 2, empleado_id: 4, empleado_nombre: "Ana Torres", fecha_inicio: daysAgo(10), fecha_fin: daysAgo(5), dias: 5, estado: "pendiente" },
];

export const rrhhEvaluaciones = [
  { id: 1, empleado_id: 1, empleado_nombre: "Carlos Mendoza", periodo: "2025-Q4", puntuacion: 92, calificacion: "Excelente", estado: "completada" },
  { id: 2, empleado_id: 2, empleado_nombre: "Laura Pérez", periodo: "2025-Q4", puntuacion: 88, calificacion: "Muy Bueno", estado: "completada" },
  { id: 3, empleado_id: 3, empleado_nombre: "Roberto Silva", periodo: "2025-Q4", puntuacion: 85, calificacion: "Bueno", estado: "pendiente" },
];

export const rrhhCapacitaciones = [
  { id: 1, nombre: "Liderazgo Empresarial", instructor: "Dr. García", fecha_inicio: daysAgo(30), fecha_fin: daysAgo(28), duracion_horas: 16, participantes: 12, estado: "completada" },
  { id: 2, nombre: "Excel Avanzado", instructor: "Ing. Rodríguez", fecha_inicio: daysAgo(15), fecha_fin: daysAgo(14), duracion_horas: 8, participantes: 20, estado: "completada" },
  { id: 3, nombre: "Seguridad Industrial", instructor: "Lic. Martínez", fecha_inicio: daysAgo(-7), fecha_fin: daysAgo(-8), duracion_horas: 24, participantes: 30, estado: "programada" },
];

export const rrhhDocumentos = [
  { id: 1, nombre: "Contrato Carlos Mendoza", tipo: "Contrato", empleado_id: 1, fecha: monthsAgo(36) },
  { id: 2, nombre: "Contrato Laura Pérez", tipo: "Contrato", empleado_id: 2, fecha: monthsAgo(24) },
  { id: 3, nombre: "Certificado Capacitación - Excel", tipo: "Certificado", empleado_id: 3, fecha: daysAgo(14) },
];

// ============ LOGÍSTICA ============
// ============ LOGÍSTICA DASHBOARD ============
export const logisticaDashboard = {
  kpis: {
    entregas: { total: 200, completadas: 156, pendientes: 12, retrasadas: 2, porcentajeExito: 96 },
    vehiculos: { total: 10, activos: 8, mantenimiento: 1, inactivos: 1, porcentajeDisponibilidad: 80 },
    rutas: { total: 15, enCurso: 5, completadas: 10, pendientes: 0, eficienciaPromedio: 94 },
    costos: { totalMes: 12500, combustible: 5000, mantenimiento: 2500, salarios: 4000, costoPromedioPorEntrega: 62.50 }
  },
  entregasPorDia: {
    labels: ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"],
    datasets: [{ label: "Entregas", data: [45, 52, 38, 60, 55, 30, 20], color: "info" }]
  },
  vehiculosPorTipo: {
    labels: ["Camión", "Van", "Motocicleta", "Sedán"],
    datasets: { label: "Flota", data: [4, 3, 2, 1], backgroundColors: ["info", "primary", "success", "warning"] }
  },
  eficienciaRutas: {
    labels: ["Ccs-Val", "Ccs-Mar", "Val-Bar"],
    datasets: [{ label: "Eficiencia %", data: [95, 88, 92], color: "info" }]
  },
  costosMensuales: {
    labels: ["Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
    datasets: [{ label: "Costos USD", data: [11000, 11500, 10800, 12000, 12500, 13000], color: "info" }]
  }
};

export const logisticaRutas = [
  { id: 1, nombre: "Ruta Caracas-Valencia", origen: "Caracas", destino: "Valencia", distancia_km: 158, tiempo_estimado: "2h 30m", estado: "activa" },
  { id: 2, nombre: "Ruta Caracas-Maracaibo", origen: "Caracas", destino: "Maracaibo", distancia_km: 694, tiempo_estimado: "8h", estado: "activa" },
  { id: 3, nombre: "Ruta Valencia-Barquisimeto", origen: "Valencia", destino: "Barquisimeto", distancia_km: 202, tiempo_estimado: "3h", estado: "activa" },
];

export const logisticaFlotas = [
  { id: 1, placa: "ABC-123", tipo: "Camión", marca: "Ford", modelo: "F-350", año: 2022, estado: "disponible", kilometraje: 45000 },
  { id: 2, placa: "DEF-456", tipo: "Camioneta", marca: "Toyota", modelo: "Hilux", año: 2023, estado: "en_ruta", kilometraje: 28000 },
  { id: 3, placa: "GHI-789", tipo: "Camión", marca: "Chevrolet", modelo: "NPR", año: 2021, estado: "disponible", kilometraje: 67000 },
  { id: 4, placa: "JKL-012", tipo: "Van", marca: "Mercedes", modelo: "Sprinter", año: 2023, estado: "mantenimiento", kilometraje: 15000 },
];

export const logisticaConductores = [
  { id: 1, nombres: "José", apellidos: "Hernández", cedula: "V-16789012", licencia: "5ta", telefono: "0414-555-4001", estado: "disponible", vehiculo_asignado: "ABC-123", rutas_completadas: 45, calificacion: 4.8 },
  { id: 2, nombres: "Pedro", apellidos: "Ramírez", cedula: "V-17890123", licencia: "5ta", telefono: "0424-555-4002", estado: "en_ruta", vehiculo_asignado: "DEF-456", rutas_completadas: 32, calificacion: 4.5 },
  { id: 3, nombres: "Luis", apellidos: "García", cedula: "V-18901234", licencia: "3ra", telefono: "0414-555-4003", estado: "disponible", vehiculo_asignado: null, rutas_completadas: 28, calificacion: 4.7 },
];

export const logisticaOrdenes = [
  { id: 1, numero: "ENV-000001", cliente: "Corporación XYZ", destino: "Valencia", ruta_id: 1, conductor_id: 2, vehiculo: "DEF-456", fecha_envio: daysAgo(0), estado: "en_transito", peso_kg: 500 },
  { id: 2, numero: "ENV-000002", cliente: "Supermercados Del Este", destino: "Caracas", ruta_id: 1, conductor_id: 1, vehiculo: "ABC-123", fecha_envio: daysAgo(1), estado: "entregado", peso_kg: 1200 },
  { id: 3, numero: "ENV-000003", cliente: "Ferretería Los Andes", destino: "Barquisimeto", ruta_id: 3, conductor_id: 3, vehiculo: "GHI-789", fecha_envio: daysAgo(0), estado: "preparando", peso_kg: 800 },
];

export const logisticaZonas = [
  {
    id: 1,
    codigo: "ZN-01",
    nombre: "Zona Norte",
    distritos: "Los Olivos, Independencia, Comas",
    radio: 15.5,
    costo_base: 25.0,
    tiempo_promedio: "45 min",
    rutas_activas: 3,
    entregas_mes: 120,
    estado: "activa",
  },
  {
    id: 2,
    codigo: "ZC-02",
    nombre: "Zona Centro",
    distritos: "Cercado, Breña, La Victoria",
    radio: 8.0,
    costo_base: 15.0,
    tiempo_promedio: "30 min",
    rutas_activas: 5,
    entregas_mes: 250,
    estado: "activa",
  },
  {
    id: 3,
    codigo: "ZS-03",
    nombre: "Zona Sur",
    distritos: "Chorrillos, Barranco, Miraflores",
    radio: 12.0,
    costo_base: 20.0,
    tiempo_promedio: "50 min",
    rutas_activas: 2,
    entregas_mes: 95,
    estado: "activa",
  },
];

export const logisticaReportes = {
  entregas_mes: 45,
  km_recorridos: 12500,
  combustible_litros: 3200,
  costo_transporte: 8500,
};

// ============ REPORTES GENERALES ============
export const reportesDashboardGeneral = {
  kpis: {
    ingresos_totales: 185000,
    ingresos_anteriores: 160000,
    utilidad_neta: 45000,
    margen_utilidad: 24.3,
    valor_inventario: 89250,
    ventas_cantidad: 156,
    clientes_activos: 45,
  },
  evolucion_financiera: [
    { mes: "Jul", ingresos: 25000, gastos: 18000, utilidad: 7000, clientes: 38 },
    { mes: "Ago", ingresos: 28000, gastos: 19500, utilidad: 8500, clientes: 40 },
    { mes: "Sep", ingresos: 30000, gastos: 21000, utilidad: 9000, clientes: 42 },
    { mes: "Oct", ingresos: 32000, gastos: 22500, utilidad: 9500, clientes: 44 },
    { mes: "Nov", ingresos: 35000, gastos: 24000, utilidad: 11000, clientes: 45 },
    { mes: "Dic", ingresos: 38000, gastos: 20000, utilidad: 18000, clientes: 46 }
  ],
  ingresos_por_modulo: [
    { modulo: "Ventas", valor: 120000 },
    { modulo: "Servicios", valor: 45000 },
    { modulo: "Suscripciones", valor: 15000 },
    { modulo: "Otros", valor: 5000 }
  ],
  gastos_por_categoria: [
    { categoria: "Operativos", valor: 45000 },
    { categoria: "Administrativos", valor: 25000 },
    { categoria: "Ventas", valor: 12000 },
    { categoria: "Otros", valor: 5000 }
  ],
  ventas_por_sucursal: [
    { nombre: "Ccs Principal", total: 85000 },
    { nombre: "Val Industrial", total: 55000 },
    { nombre: "Mar Centro", total: 30000 },
    { nombre: "Bqto Oriente", total: 15000 }
  ],
  indicadores_financieros: [
    { title: "ROE", value: 18.5 },
    { title: "ROA", value: 12.2 },
    { title: "Liquidez", value: 2.4 },
    { title: "Endeudamiento", value: 42.8 }
  ],
  indicadores_operativos: [
    { title: "Rotación Inventario", value: 45.8 },
    { title: "Eficiencia General", value: 94.2 }
  ]
};

export const reportesVentasOperativo = {
  kpis: {
    total_ventas: 185000,
    numero_ventas: 156,
    ticket_promedio: 1185.90,
  },
  tendencia_ventas: [
    { mes: "Ene", ingresos: 25000 },
    { mes: "Feb", ingresos: 28000 },
    { mes: "Mar", ingresos: 22000 },
    { mes: "Abr", ingresos: 32000 },
    { mes: "May", ingresos: 38000 },
    { mes: "Jun", ingresos: 40000 },
  ],
  top_productos: productos.slice(0, 5).map((p) => ({
    nombre: p.nombre,
    total_vendido: Math.floor(Math.random() * 50 + 10),
    total_ingresos: (Math.random() * 5000 + 500).toFixed(2),
    precio: p.precio
  })),
};

export const reportesInventarioOperativo = {
  kpis: {
    valor_total: 89250,
    total_productos: 8,
    productos_stock_bajo: 0,
  },
  productos: productos.map(p => ({
    nombre: p.nombre,
    cantidad: p.stock,
    precio: p.precio
  })),
};

export const reportesComparativo = {
  comparacion_empresas: [
    {
      nombre: "SADEMS C.A.",
      ingresos_mensuales: [25000, 28000, 22000, 32000, 38000, 40000],
      ingresos_totales: 185000,
      costos_totales: 140000,
      utilidad: 45000,
      margen: 24.3,
      crecimiento: 15.6
    },
    {
      nombre: "Distribuidora Norte",
      ingresos_mensuales: [15000, 18000, 16000, 20000, 22000, 25000],
      ingresos_totales: 116000,
      costos_totales: 95000,
      utilidad: 21000,
      margen: 18.1,
      crecimiento: 12.4
    }
  ],
  comparacion_sucursales: [
    {
      nombre: "Ccs Principal",
      ventas_mes_actual: 45000,
      ventas_mes_anterior: 38000,
      ventas_totales: 85000,
      num_transacciones: 320,
      ticket_promedio: 140.6,
      eficiencia: 95
    },
    {
      nombre: "Val Industrial",
      ventas_mes_actual: 32000,
      ventas_mes_anterior: 28000,
      ventas_totales: 60000,
      num_transacciones: 210,
      ticket_promedio: 152.3,
      eficiencia: 88
    }
  ],
  comparacion_periodos: {
    "2024": [85000, 92000, 88000, 95000],
    "2025": [98000, 105000, 0, 0]
  }
};

export const reportesIndicadores = {
  kpis: [
    { title: "ROE", value: 18.5, suffix: "%", change: 2.3 },
    { title: "ROA", value: 12.2, suffix: "%", change: 1.5 },
    { title: "ROI", value: 45.8, suffix: "%", change: 5.2 },
    { title: "EBITDA", value: 65000, suffix: "", change: 8.4 },
    { title: "Liquidez Corriente", value: 2.2, suffix: "x", change: 0.1 },
    { title: "Prueba Ácida", value: 1.8, suffix: "x", change: -0.2 },
    { title: "Rotación Inventario", value: 45, suffix: " días", change: -3 },
    { title: "Ciclo de Caja", value: 35, suffix: " días", change: -5 }
  ]
};

export const reportesFinancieros = {
  ingresos: contabilidadEstadoResultados,
  balance: contabilidadBalanceGeneral,
  flujo: contabilidadFlujoCaja,
};

export const reportesCompras = {
  estadisticas: {
    totalCompras: compras.length,
    montoTotal: parseFloat(compras.reduce((sum, c) => sum + c.total, 0).toFixed(2)),
    proveedoresActivos: proveedores.length,
    promedioCompra: parseFloat((compras.reduce((sum, c) => sum + c.total, 0) / (compras.length || 1)).toFixed(2))
  },
  proveedoresTop: proveedores.slice(0, 5).map(p => ({
    nombre: p.nombre,
    compras: Math.floor(Math.random() * 10 + 1),
    total: (Math.random() * 5000 + 1000).toFixed(2)
  })),
  productosMasComprados: productos.slice(0, 5).map(p => ({
    nombre: p.nombre,
    cantidad: Math.floor(Math.random() * 100 + 10),
    monto: (Math.random() * 8000 + 2000).toFixed(2)
  }))
};

// ============ AUDITORÍA ============
export const auditLogs = [
  { id: 1, usuario: "demo@sadems.com", accion: "LOGIN", modulo: "Auth", descripcion: "Inicio de sesión exitoso", ip: "192.168.1.100", fecha: daysAgo(0) + " 08:30:00" },
  { id: 2, usuario: "maria@sadems.com", accion: "CREATE", modulo: "Ventas", descripcion: "Creación de factura FAC-000025", ip: "192.168.1.101", fecha: daysAgo(0) + " 09:15:00" },
  { id: 3, usuario: "carlos@sadems.com", accion: "UPDATE", modulo: "Inventario", descripcion: "Ajuste de stock producto ELEC-001", ip: "192.168.1.102", fecha: daysAgo(0) + " 10:00:00" },
  { id: 4, usuario: "demo@sadems.com", accion: "DELETE", modulo: "Empresas", descripcion: "Eliminación de empresa ID 6", ip: "192.168.1.100", fecha: daysAgo(1) + " 14:20:00" },
  { id: 5, usuario: "ana@sadems.com", accion: "CREATE", modulo: "Contabilidad", descripcion: "Registro de asiento contable AS-000004", ip: "192.168.1.103", fecha: daysAgo(1) + " 16:45:00" },
  { id: 6, usuario: "demo@sadems.com", accion: "EXPORT", modulo: "Reportes", descripcion: "Exportación de reporte financiero", ip: "192.168.1.100", fecha: daysAgo(2) + " 11:30:00" },
];

// ============ CONFIGURACIÓN ============
export const configuracion = {
  empresa_nombre: "SADEMS Demo",
  moneda: "USD",
  impuesto_default: 16,
  formato_fecha: "DD/MM/YYYY",
  zona_horaria: "America/Caracas",
  backup_auto: true,
  notificaciones: true,
};
